import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

const AiBulkEditorPage = lazy(() => import("../../pages/AiBulkEditor"));

export function AndrewLiuRoutes() {
  return (
    <Switch>
      <Route path="/al/ai-bulk-editor" component={AiBulkEditorPage} />
    </Switch>
  );
}

export const slug = "al";
